<template>
    <div class="component-group">
       <div class="panel-group">
          <el-collapse-item class='panel-title' title="分组统计">
            <el-form class="form">
              <el-form-item label="是否启动分组统计">
                <el-switch v-model="groupByEnable"/>
              </el-form-item>

              <template v-for="(group, index) in groupBies">
                <div class="type-content" :key="index">
                  <el-row class="type-filter">
                    <el-col :span="16"><label>统计依据</label></el-col>
                    <el-col class="type-icon" :span="8">
                      <span class="left-icon el-icon-plus" @click="addGroup(index)"></span>
                      <span class="right-icon el-icon-minus" @click="delGroup(index)"></span>
                    </el-col>
                  </el-row>
                  <el-row class="input-type">
                    <public-combobox v-model="group.columnId" :options="columns" :disabled="{key: 'group-panel', group}"></public-combobox>
                  </el-row>
                </div>
              </template>
            </el-form>
          </el-collapse-item>
      </div>
    </div>
</template>

<script>
import Group from '@/store/report/group.js'
import publicCombobox from '@/components/public/public-combobox.vue'

export default {
  name: 'GroupPanel',
  inject: ['reportService'],
  props: ['groupBies'],
  components: {publicCombobox},
  data () {
    let groupByEnable = this.$_.clone(this.reportService.report.groupByEnable)
    return {
      groupByEnable
    }
  },
  methods: {
    addGroup (index) {
      if (this.groupByEnable) {
        let group = new Group()
        //  在当前这行后面插入一个group
        this.groupBies.splice(index + 1, 0, group)
      }
    },
    delGroup (index) {
      if (this.groupByEnable) {
        if (this.groupBies.length > 1) {
          this.groupBies.splice(index, 1)
        } else {
          this.$message({
            showClose: true,
            message: '至少保留一行',
            type: 'info'
          })
        }
      }
    }
  },
  watch: {
    groupBies: {
      handler (value) {
        this.$emit('updateGroup', value)
      },
      deep: true
    },
    groupByEnable (updateGroupByEnable) {
      if (!updateGroupByEnable) {
        // 清空所有的 groupBies
        this.groupBies.forEach((e, i) => {
          this.groupBies.splice(i, 1)
        })
        // 至少需要保留一个 group
        this.groupBies.push(new Group())
      }
      this.$emit('updateGroupByEnable', updateGroupByEnable)
    }
  },
  computed: {
    columns () {
      let columns = this.reportService.report.columns
      return columns.map(m => {
        // 每次下拉框选择完，column中被选择过的会被过滤
        const used = this.groupBies.map(o => o.columnId).includes(m.id)
        return { ...m, used }
      })
    }
  }
}
</script>

<style lang="scss">
.panel-group {
  .el-collapse-item__content {
    padding-bottom: 0;
  }
  .form {
    .left-icon,.right-icon{
      font-size: 10px;
      font-weight: 700;
    }
     .left-icon{
       color:#76e0bc;
        &:active{
        color:#49c38e;
        }
     }
     .right-icon{
       color:#F64D5E;
        &:active{
        color:#d70909
        }
     }
    .el-form-item {
      margin: 0;
      .el-form-item__label{
        font-size: 12px;
      }
      .el-form-item__content {
        float: right;
      }
    }
    .group {
      .el-form-item__label {
        padding: 0 6px 0 0;
      }

      [class*=" el-icon-"],
      [class^=el-icon-] {
        cursor: pointer;
        margin-right: 0;
      }
    }
    .type-content{
      label{
        font-size: 12px;
      }
    }
  }

}
</style>



// WEBPACK FOOTER //
// src/components/report/design/group-panel.vue